import { render, staticRenderFns } from "./ImagesUploader.vue?vue&type=template&id=5b71e0b8"
import script from "./ImagesUploader.vue?vue&type=script&lang=js"
export * from "./ImagesUploader.vue?vue&type=script&lang=js"
import style0 from "./ImagesUploader.vue?vue&type=style&index=0&id=5b71e0b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports